import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import { closeModal } from 'modal/store/actions';
import FieldWrapper from 'base/components/forms/FieldWrapper';
import Title3 from 'base/components/Title3';
import MainTitle from 'base/components/MainTitle';
import SubmitButton from 'base/components/forms/SubmitButton';
import { FormikSelectField } from 'base/components/forms/formik';
import ModalHeader from 'modal/components/ModalHeader';
import {
  addDefaultFavorite,
  removeDefaultFavorite,
  fetchDashboardsWithFavoriteDocument,
  getEditingDocumentDashboardIdsWithFavorite,
  getEditingDocumentDashboardIdsWithFavoriteIsLoading,
} from '../../../favorites';
import { getActivePathStringWithSpace, getEditingFolder } from '../../store/folders/selectors';
import { getDefaultDashboardsSelectOptions, fetchAllDefaultDashboards } from '../../../dashboard';
import { getAllTags } from '../../store/tags/selectors';
import { getActiveDocument } from '../../store/documents/selectors';
import { updateDocument } from '../../store/documents/actions';

class DocumentEditDefaultFavoritesModal extends React.Component {
  componentDidMount() {
    this.props.fetchAllDefaultDashboards();
    if (this.props.document) {
      this.fetchOldValues(this.props.document);
    }
    if (this.props.folder) {
      this.fetchOldValues(this.props.folder);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (!prevProps.document && this.props.document) ||
      (prevProps.document && this.props.document && prevProps.document.id !== this.props.document.id)
    ) {
      this.fetchOldValues(this.props.document);
    }
    if (
      (!prevProps.folder && this.props.folder) ||
      (prevProps.folder && this.props.folder && prevProps.folder.id !== this.props.folder.id)
    ) {
      this.fetchOldValues(this.props.folder);
    }
  }

  fetchOldValues = document => this.props.fetchDashboardsWithFavoriteDocument(document.entityType, document.id);

  render() {
    const {
      name,
      document,
      folder,
      closeModal,
      defaultDashboardsSelectOptions,
      activePathString,
      oldValues,
      oldValuesIsLoading,
      addDefaultFavorite,
      removeDefaultFavorite,
    } = this.props;

    const entity = document || folder;

    const form = (
      <Formik
        initialValues={{
          name: document?.name || folder?.name,
          defaultFavorites: oldValues || [],
        }}
        render={(
          { errors, isSubmitting }, // eslint-disable-line
        ) => (
          <Form>
            <Field
              type="select"
              name="defaultFavorites"
              component={FormikSelectField}
              placeholder=""
              label="Show as default favorite on the following default dashboards"
              isMulti
              options={defaultDashboardsSelectOptions}
            />

            <SubmitButton type="submit" disabled={isSubmitting}>
              Update
            </SubmitButton>
          </Form>
        )}
        onSubmit={values => {
          const newValues = values.defaultFavorites || [];
          const toAdd = newValues.filter(id => !oldValues.includes(id));
          const toRemove = oldValues.filter(id => !newValues.includes(id));
          if (toAdd) {
            toAdd.forEach(id => addDefaultFavorite(id, entity.entityType, entity.id));
          }
          if (toRemove) {
            toRemove.forEach(id => removeDefaultFavorite(id, entity.entityType, entity.id));
          }

          closeModal(name);
        }}
      />
    );

    return (
      <>
        <ModalHeader>
          <MainTitle>Manage default favorites for {entity?.entityType}</MainTitle>
        </ModalHeader>

        <FieldWrapper>
          <div>{activePathString}</div>
          <Title3>{entity?.name}</Title3>
        </FieldWrapper>

        {oldValuesIsLoading ? 'Loading...' : form}
      </>
    );
  }
}

DocumentEditDefaultFavoritesModal.propTypes = {
  name: PropTypes.string.isRequired,
  document: PropTypes.objectOf(PropTypes.any).isRequired,
  folder: PropTypes.objectOf(PropTypes.any).isRequired,
  defaultDashboardsSelectOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  closeModal: PropTypes.func.isRequired,
  fetchAllDefaultDashboards: PropTypes.func.isRequired,
  activePathString: PropTypes.string.isRequired,
  fetchDashboardsWithFavoriteDocument: PropTypes.func.isRequired,
  oldValues: PropTypes.arrayOf(PropTypes.number).isRequired,
  oldValuesIsLoading: PropTypes.bool.isRequired,
  addDefaultFavorite: PropTypes.func.isRequired,
  removeDefaultFavorite: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  document: getActiveDocument(state),
  folder: getEditingFolder(state),
  tags: getAllTags(state),
  defaultDashboardsSelectOptions: getDefaultDashboardsSelectOptions(state),
  activePathString: getActivePathStringWithSpace(state),
  oldValues: getEditingDocumentDashboardIdsWithFavorite(state),
  oldValuesIsLoading: getEditingDocumentDashboardIdsWithFavoriteIsLoading(state),
});

const mapDispatchToProps = {
  updateDocument,
  closeModal,
  fetchAllDefaultDashboards,
  addDefaultFavorite,
  removeDefaultFavorite,
  fetchDashboardsWithFavoriteDocument,
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentEditDefaultFavoritesModal);
